module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_mobile_02.91520fd4.png";